import { Component, Input, OnInit, inject } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { Encounter } from '../../../core/models/encounter.model';
import { Referral } from '../../../core/models/referral.model';
import { PatientService } from '../../../core/services/patient.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgTemplateOutlet, NgClass, TitleCasePipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-validate-patient-care-ownership',
    templateUrl: './validate-patient-care-ownership.component.html',
    styleUrls: ['./validate-patient-care-ownership.component.scss'],
    imports: [NgTemplateOutlet, NgClass, RouterLink, TitleCasePipe, DatePipe]
})
export class ValidatePatientCareOwnershipComponent implements OnInit {
  private patientService = inject(PatientService);

  @Input() capture: Capture;

  closestPatientInteractionEhrIdentifier: string;
  closestPatientInteractionDate: string;
  closestPatientInteractionType: string;
  closestPatientInteractionProviderName: string;
  closestPatientInteractionLocation: string;
  closestPatientInteractionEncounterType: string;
  closestPatientInteractionValid: boolean;
  patientInteractionIsVerified: boolean;
  eligibleEncounters: Encounter[] = [];
  ineligibleEncounters: Encounter[] = [];
  currentTab = 'eligibleEncounters';
  showIneligibleEncounters = false;
  moreEncountersThanDisplayed = false;

  ngOnInit() {
    if (this.capture.verifyingEncounter) {
      this.setClosestPatientInteractionDataFromEncounter(this.capture.verifyingEncounter, true);
    } else if (this.capture.closestEncounter) {
      this.setClosestPatientInteractionDataFromEncounter(
        this.capture.closestEncounter,
        this.capture.closestEncounterValid
      );
    }
    this.patientInteractionIsVerified = !!this.capture.verifyingEncounter || !!this.capture.verifyingReferral;
    this.loadEncounters();
  }

  setClosestPatientInteractionDataFromEncounter(encounter: Encounter, valid: boolean) {
    this.closestPatientInteractionType = 'ENCOUNTER';
    this.closestPatientInteractionEhrIdentifier = encounter.ehrIdentifier;
    this.closestPatientInteractionDate = encounter.encounterDate;
    this.closestPatientInteractionProviderName = this.encounterProviderFullName(encounter);
    this.closestPatientInteractionLocation = encounter.location;
    this.closestPatientInteractionEncounterType = encounter.encounterType;
    this.closestPatientInteractionValid = valid;
  }

  loadEncounters(): void {
    const patientId = this.capture.patient.id;

    this.patientService.getEncounters(patientId).subscribe(
      result => {
        if (result.meta.eligibilityBasedOnLocation) {
          this.showIneligibleEncounters = true;

          this.eligibleEncounters =
            result.encounters.filter(encounter => encounter.locationEligibleDuringServiceDate);

          this.ineligibleEncounters =
            result.encounters.filter(encounter => !encounter.locationEligibleDuringServiceDate);
        } else {
          this.showIneligibleEncounters = false;
          this.eligibleEncounters = result.encounters;
        }
        if (result.meta.paging.count > result.meta.paging.pageSize) {
          this.moreEncountersThanDisplayed = true;
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  encounterProviderFullName(encounter: Encounter) {
    return `${encounter.providerFirst} ${encounter.providerLast} (NPI ${encounter.providerNpi})`;
  }

  referralProviderFullName(referral: Referral) {
    return `${referral.sendingProviderFirst} ${referral.sendingProviderLast} (NPI ${referral.sendingProviderNpi})`;
  }

  get patientOwnershipTimeframeInMonths(): number {
    return this.capture.client.patientOwnershipTimeframeInMonths;
  }

  tabClick($event: MouseEvent, tabName: string) {
    $event.preventDefault();
    this.currentTab = tabName;
  }
}
